import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'objectToArray'
})
export class ObjectToArrayPipe implements PipeTransform {

  /**
   * Convert an object to array
   * @param {object} value
   * @returns {any[]}
   */
  transform(value: object): any[] {
    const array = Object.keys(value).map(key => {
      if (typeof value[key] === 'object') {
        const item = value[key];
        item.key = key;
        if (value[key]) {
          return value[key];
        } else {
          return null;
        }
      }
    });
    return Object.values(array.filter(item => item));
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/object-to-array.pipe.ts